import { create } from "zustand";
import type { CustomerData } from "../types/customer-data";

type CustomerDataState = {
  customerData?: CustomerData;
  setCustomerData: (customerData: CustomerData) => void;
  clearCustomerData: () => void;
};

export const useCustomerDataState = create<CustomerDataState>((set) => ({
  setCustomerData: (customerData) =>
    set(() => ({
      customerData,
    })),
  clearCustomerData: () =>
    set(() => ({
      customerData: undefined,
    })),
}));
